import React, { useState } from 'react';
import { Modal, Button, ButtonGroup } from '@cimpress/react-components';

const variations = [
  { type: 'plain', status: undefined },
  { type: 'warning', status: 'warning' },
  { type: 'danger', status: 'danger' },
  { type: 'success', status: 'success' },
  { type: 'info', status: 'info' },
];

export default function ModalDemo() {
  const [modalState, setModalState] = useState(() => ({ open: false, status: undefined }));
  const [childOpen, setChildOpen] = useState(false);
  const closeModal = () => setModalState({ open: false, status: undefined });

  return (
    <div>
      <ButtonGroup>
        {variations.map(variation => (
          <Button key={variation.type} onClick={() => setModalState({ open: true, status: variation.status })}>
            Launch {variation.type} modal
          </Button>
        ))}
        <Button style={{ color: 'red' }} onClick={() => setChildOpen(true)}>
          Launch child modal
          <Modal
            status="success"
            show={childOpen}
            onRequestHide={() => setChildOpen(false)}
            title="An example modal"
            closeButton={true}
            footer={<Button onClick={() => setChildOpen(false)}>Close</Button>}
          >
            <p>
              I am a modal body from inside a button (and I didn't inherit the red text of my parent component, thanks
              to React Portals)!
            </p>
            <p>I also stop events from propagating to the parent.</p>
          </Modal>
        </Button>
      </ButtonGroup>

      <Modal
        status={modalState.status}
        className="foobar"
        show={modalState.open}
        onRequestHide={closeModal}
        title="An example modal"
        closeButton={true}
        footer={<Button onClick={closeModal}>Close</Button>}
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam asperiores, quidem quos eaque error odit
          itaque, quo eveniet consectetur nesciunt inventore numquam repellendus. Laboriosam repellendus, ea alias
          debitis hic incidunt! Molestiae sed ad earum distinctio eaque laborum culpa necessitatibus? Dolorem sequi
          officiis atque facilis est repudiandae aut voluptatum veniam voluptas.
        </p>
      </Modal>
    </div>
  );
}
